<template>
  <v-layout wrap>
    <v-navigation-drawer
      v-model="openDrawer"
      fixed
      right
      temporary
      :width="drawerWidth"
      class="filter-nav-drawer primary"
      enable-resize-watcher
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
    <v-btn 
      v-show="closeBtn" 
      fab 
      small 
      absolute 
      color="orange"
      class="closeBtn" 
      @click="openDrawer = !openDrawer">
        <v-icon>close</v-icon>
      </v-btn>
    <div class="pa-3">
      <slot></slot>
    </div>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
export default {
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },
    closeBtn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    openDrawer: {
      get() {
        return this.open
      },
      set(value) {
        this.$emit('change:state', value)
      }
    },
    drawerWidth() {
      return this.$vuetify.breakpoint.width < 510 ? 300 : 400;
    }
  }
}
</script>

<style scoped>
.closeBtn {
  right: 0px;
  margin: 15px;
  position: absolute !important;
}

.filter-nav-drawer {
  height: 100vh; 
  z-index: 11 !important;
}
</style>
